export default __webpack_public_path__ + "static/media/paymentLink 2.ae99c483.svg";